import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType } from 'components/list/DynamicListFilterUtils';

import { ENUMS, USER_GROUPS_MODULE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const UserGroupList = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'userGroupId', filterType: FilterType.number, show: false },
			{
				Header: 'groupName',
				accessor: 'name',
				filterType: FilterType.string
			},
			{
				Header: 'warehouse',
				accessor: 'WarehouseName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.WAREHOUSES
			},
			{
				Header: 'warehouseID',
				accessor: 'warehouseID',
				filterType: FilterType.number,
				show: false
			},
			{
				Header: 'users',
				accessor: 'userNames',
				filterType: FilterType.string
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.string
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.USER_GROUPS}
				fetchUrl={USER_GROUPS_MODULE.GET_WMS_USER_GROUPS_LIST}
				columns={columns}
				exportName="wmsUserGroups"
				actionObjectType={ACTION_OBJECT_TYPES.USER_GROUP}
			/>
		</TabTableContainer>
	);
};

export default UserGroupList;
